import React from 'react'
import classnames from 'classnames'
import { loadBets } from '../../actions'
import { connectPagination } from '../../decorators'
import { Schemas } from '../../middleware/api'
import { TableList } from '../Generic'

import get from 'lodash/get'

class BetList extends React.Component {
  _rowClassName = ({ rowData, index }) => {
    const { selected } = this.props;
    return classnames(
      'table-row', 
      {'table-row--is-hit': selected && get(selected, 'id') === rowData.id}
    )
  }

  render() {
    const { rowClassName, isTableView, entity, pagination, totalItems, stickyStyle, stickyTopOffset } = this.props;

    let content = <TableList 
      {...this.props}
      stickyStyle={stickyStyle}
      stickyTopOffset={stickyTopOffset}
      rowClassName={rowClassName || this._rowClassName} />

    if(isTableView) {
      content =
        <div className="generic-table-wrapper">
        { !totalItems && get(pagination, 'isFetching')  && <div className="table-info-header">Loading {entity}...</div> }
        { this.props.title && <div className="table-title">{this.props.title}</div>}

        { this.props.totalItems > 0 && <div className="table-info-header">showing {this.props.totalItems} {entity}...</div> }

        <TableList 
          {...this.props}
          stickyStyle={stickyStyle}
          stickyTopOffset={stickyTopOffset}
          rowClassName={rowClassName || this._rowClassName} />
      </div>
    }

    return content;
  }
}

export default connectPagination({
  entitykey: 'bets',
  loadItems: loadBets,
  itemSchema: Schemas.BET,
  getQueryParams: ({state, ownProps}) => {
    return {
      player__id: ownProps.playerId,
      event__begin__gte: ownProps.beginGt,
      event__begin__lte: ownProps.beginLt,
      ticket__id: ownProps.ticketId,
      // expand: 'event, market',
      ordering: ownProps.ordering || '-delivery_date',
      ...get(state, 'routing.locationBeforeTransitions.query'),
    }
  },
  title: 'Player Bets Pagination',
})(BetList)


// WEBPACK FOOTER //
// ./src/components/Players/BetsList.js